export default {"src":"/_next/static/media/logo.e5856ef6.svg","height":258,"width":1200,"blurWidth":0,"blurHeight":0};